import React, {useState} from 'react';
import {useFormContext} from "react-hook-form";

import css from './OrdersSunSatDaysModal.module.css';


const OrdersSunSatDaysModal = () => {
    const {register, setValue} = useFormContext();
    const [isSatChecked, setIsSatChecked] = useState(false);  // Track Sat checkbox state
    const [isSunChecked, setIsSunChecked] = useState(false);  // Track Sun checkbox state

    // Handle checkbox change and update state
    const handleCheckboxChange = (e) => {
        const {id, checked} = e.target;
        if (id === 'sat') {
            setIsSatChecked(checked);
        } else if (id === 'sun') {
            setIsSunChecked(checked);
        }
        setValue(id, checked);
    };


    return (
        <div className={css.wrap}>
            <div className={css.inputGroup}>
                <input
                    type="checkbox"
                    id="sat"
                    checked={isSatChecked}
                    {...register('sat')}
                    onChange={handleCheckboxChange}
                />
                <label htmlFor="sat">Sat</label>
            </div>

            <div className={css.inputGroup}>
                <input
                    type="checkbox"
                    id="sun"
                    checked={isSunChecked}
                    {...register('sun')}
                    onChange={handleCheckboxChange}
                />
                <label htmlFor="sun">Sun</label>
            </div>
        </div>
    );
};

export {OrdersSunSatDaysModal};




